import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Label,
  Legend,
} from "recharts";

const data = [
  { month: "Jan", Revenue: 4500000, Profit: 3000000, Expenses: 1500000 },
  { month: "Feb", Revenue: 5000000, Profit: 3500000, Expenses: 1800000 },
  { month: "Mar", Revenue: 3200000, Profit: 2000000, Expenses: 1200000 },
  { month: "Apr", Revenue: 4000000, Profit: 2800000, Expenses: 1700000 },
  { month: "May", Revenue: 3700000, Profit: 2500000, Expenses: 1600000 },
  { month: "Jun", Revenue: 4200000, Profit: 3000000, Expenses: 1800000 },
  { month: "Jul", Revenue: 4600000, Profit: 3200000, Expenses: 2000000 },
  { month: "Aug", Revenue: 3900000, Profit: 2700000, Expenses: 1500000 },
  { month: "Sep", Revenue: 4400000, Profit: 3100000, Expenses: 1700000 },
  { month: "Oct", Revenue: 4100000, Profit: 2800000, Expenses: 1600000 },
  { month: "Nov", Revenue: 4800000, Profit: 3400000, Expenses: 1900000 },
  { month: "Dec", Revenue: 5500000, Profit: 3800000, Expenses: 2000000 },
];

const FinancialBarChart = () => {
  return (
    <ResponsiveContainer width="98%" height={400}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 50, bottom: 10 }}
      >
        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label value="Months" position="insideBottom" offset={-10} />
        </XAxis>
        <YAxis
          domain={[0, 6000000]}
          ticks={[0, 1500000, 3000000, 4500000, 6000000]}
          axisLine={{ stroke: "#D9D9D9" }}
          tickFormatter={(value) => value.toLocaleString()}
        />
        <Tooltip formatter={(value) => value.toLocaleString()} />

        {/* Legend inside chart, but forced below using wrapperStyle */}
        <Legend
          layout="horizontal"
          verticalAlign="bottom"
          align="center"
          wrapperStyle={{
            paddingTop: 30, // pushes it down away from x-axis
          }}
        />

        <Bar dataKey="Revenue" fill="#074073" />
        <Bar dataKey="Profit" fill="#8ED6A8" />
        <Bar dataKey="Expenses" fill="#FF5757" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default FinancialBarChart;
